import { FC } from "react";

export const Index: FC = () => (
    <></>
)

export default Index